document.addEventListener("DOMContentLoaded", function () {
    const colorOptions = document.querySelectorAll(".color-option");
    const images = document.querySelectorAll(".corresponding-image");
    const mainImage = document.querySelector(".main-image");

    colorOptions.forEach(option => {
        option.addEventListener("click", () => {
            const selectedColor = option.getAttribute("data-color");

            // hide all images
            images.forEach(img => {
                img.style.display = "none";
            });
            mainImage.style.display = "none";

            // show matching image
            const targetImage = document.querySelector(`.corresponding-image[data-color="${selectedColor}"]`)
            if (targetImage) {
                targetImage.style.display = "block";
            }
        })
    })
})